export const getImageUrl = async (src) => {
  try {
    const response = await fetch(src, { mode: 'no-cors' });
    return src; // La risposta sarà opaca e non potrai utilizzare l'URL finale
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return null;
  }
};